import { callBackendApi } from "../../../../../components/service/axios";

export const fetchUserAccessHistory = async (userId) => {
  return await callBackendApi("get", "/bff/user-access-history", null, {
    userId: userId,
  });
};
